import React from 'react';
import { Box, Flex, Button } from 'rebass/styled-components';
import { ChevronDown, MoreHorizontal } from 'lucide-react';
import PropTypes from 'prop-types';
import { Card } from 'components/atoms/Card';
import { Dropdown } from 'components/molecules/dropdown';

export const TableRowActions = React.memo(({ row, rowActions, useHorizontalActions = true }) => (
  <Box
    sx={{
      minWidth: useHorizontalActions ? '24px' : '60px',
      maxHeight: '24px',
      height: '24px',
      justifyContent: useHorizontalActions ? 'center' : 'space-between',
      cursor: 'pointer',
      alignItems: 'center',
    }}
    tx="dataTable"
    data-testid="row-action"
    display="flex"
  >
    <Dropdown
      placement="right-start"
      trigger={
        useHorizontalActions ? (
          <Box
            size="16px"
            variant="icon"
            sx={{ stroke: 'text' }}
            strokeWidth="1.5"
            aria-hidden="true"
            as={MoreHorizontal}
          />
        ) : (
          <Flex width="100%" justifyContent="space-between" alignItems="center" sx={{ gap: '4px' }}>
            <Box color="text.subtle" fontSize="12px" lineHeight="24px">
              Actions
            </Box>
            <Box
              size="16px"
              variant="icon"
              sx={{ stroke: 'text', color: 'text.subtle' }}
              strokeWidth="1.5"
              aria-hidden="true"
              as={ChevronDown}
            />
          </Flex>
        )
      }
    >
      <Card variant="card.default" sx={{ width: '200px' }} py={2} px={0}>
        <Flex flexDirection="column" width="200px">
          {rowActions.items.map(
            ({
              isDisabled = () => false,
              Item = Button,
              onClick = () => {},
              title,
              children,
              rowActionKey,
              ...props
            }) => {
              const job = row.original;
              const resolvedTitle = typeof title === 'function' ? title(job) : title;
              const resolvedChildren = typeof children === 'function' ? children(job) : children;
              return (
                <Item
                  key={`row_actions_${row.id}_${rowActionKey ?? resolvedTitle}`}
                  row={row}
                  width={1}
                  textAlign="left"
                  variant="tertiary"
                  pl="16px"
                  py="4px"
                  fontSize="14px"
                  title={resolvedTitle}
                  {...props}
                  disabled={isDisabled(job)}
                  onClick={() => onClick(job)}
                >
                  {resolvedChildren}
                </Item>
              );
            },
          )}
        </Flex>
      </Card>
    </Dropdown>
  </Box>
));

TableRowActions.propTypes = {
  row: PropTypes.object.isRequired,
  rowActions: PropTypes.object.isRequired,
  useHorizontalActions: PropTypes.bool,
};

TableRowActions.defaultProps = {
  useHorizontalActions: true,
};

export default TableRowActions;
